
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, Save } from 'lucide-react';

interface CampaignNavigationProps {
  activeStep: string;
  isStepComplete: (step: string) => boolean;
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  handleSaveCampaign: () => Promise<boolean>;
  isSubmitting: boolean;
}

const CampaignNavigation: React.FC<CampaignNavigationProps> = ({
  activeStep,
  isStepComplete,
  handlePreviousStep,
  handleNextStep,
  handleSaveCampaign,
  isSubmitting
}) => {
  return (
    <div className="flex justify-between mt-8">
      {activeStep !== 'details' ? (
        <Button 
          variant="outline" 
          onClick={handlePreviousStep}
          className="gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Previous Step
        </Button>
      ) : (
        <div></div>
      )}
      
      {activeStep !== 'review' ? (
        <Button 
          onClick={handleNextStep}
          disabled={!isStepComplete(activeStep)}
          className="gap-2"
        >
          Next Step
          <ArrowRight className="h-4 w-4" />
        </Button>
      ) : (
        <Button 
          onClick={handleSaveCampaign}
          disabled={isSubmitting}
          className="gap-2"
        >
          Save Campaign
          <Save className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default CampaignNavigation;
